import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatVoltage } from '../utils/string'
import { ReactNode } from 'react'
import { Generator } from '../types'

export interface GeneratorNominalVoltageSelectProps extends Omit<SelectProps<number>, 'value'> {
  generator?: Generator
  value?: number | null
  helperText?: string
  onValueChange?: (value: number) => void
}

export default function GeneratorNominalVoltageSelect({
  generator,
  value,
  label,
  fullWidth,
  error,
  helperText,
  onChange,
  onValueChange,
  ...props
}: GeneratorNominalVoltageSelectProps) {
  const { t } = useTranslation('generator')

  const options: number[] = [230, 400]

  const isCustomValue = value != null && !options.includes(value)

  function handleChange(event: SelectChangeEvent<number>, child: ReactNode) {
    onChange?.(event, child)

    const selectedValue = event.target.value as number
    onValueChange?.(selectedValue)
  }

  return (
    <FormControl fullWidth={fullWidth} error={error}>
      <InputLabel>{label ?? t('nominalVoltage')}</InputLabel>
      <Select
        name="nominalVoltage"
        {...props}
        label={label ?? t('nominalVoltage')}
        value={value || ''}
        onChange={handleChange}
      >
        {isCustomValue && (
          <MenuItem key={value} value={value!}>
            {formatVoltage(value, true, 0)}
          </MenuItem>
        )}

        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {formatVoltage(option, true, 0)}
          </MenuItem>
        ))}
      </Select>

      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  )
}
